(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('MegafonFreeNumbersController', MegafonFreeNumbersController);

    MegafonFreeNumbersController.$inject = ['$state', 'AlertService', 'UIFormAccess', 'MegafonFreeNumbersService'];

    function MegafonFreeNumbersController($state, AlertService, UIFormAccess, MegafonFreeNumbersService) {

        var vm = this;

        vm.UIFormAccess = UIFormAccess;

        loadAll();
        vm.loadAll = loadAll;
        vm.lock = lockNumber;
        vm.sim = simNumber;
        vm.lockVirtual = lockForTimeoutNumber;

        function loadAll () {
            MegafonFreeNumbersService.getfree({}, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.numbers = [];
		for (var key in data) {
		    if (data.hasOwnProperty(key)) {
			vm.numbers.push({number:key, error:0, msg:data[key], locked:false});
		    }
		}

		// vm.numbers = data.map(function(a){
                // return {number: a, error: 0, msg: '', locked: false};
                // });
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }


        function lockNumber(a) {
            a.locked = true;
            vm.numbers.forEach(function(a){a.error=0});
            MegafonFreeNumbersService.moveToLocked(a.number, onSuccess, onError);
            function onSuccess(data, headers) {
                loadAll();
            }
            function onError(error) {
                a.locked = false;
                a.error = 1;
                AlertService.error(error.data.message);
                setTimeout(function() {
                    a.error = 0;
                }, 5000);
            }
        }

        function lockForTimeoutNumber(a) {
            a.locked = true;
            vm.numbers.forEach(function(a){a.error=0});
            MegafonFreeNumbersService.setLockTime(a.number, onSuccess, onError);
            function onSuccess(data, headers) {
                a.locked = true;
                a.number = a.number + " зарезервирован на 10 минут";
            }
            function onError(error) {
                a.locked = false;
                a.error = 1;
                AlertService.error(error.data.message);
                setTimeout(function() {
                    a.error = 0;
                }, 5000);
            }
        }

        function simNumber(a) {
            a.locked = true;
            vm.numbers.forEach(function(a){a.error=0});
            MegafonFreeNumbersService.moveToSim(a.number, onSuccess, onError);
            function onSuccess(data, headers) {
                loadAll();
            }
            function onError(error) {
                a.locked = false;
                a.error = 1;
                AlertService.error(error.data.message);
                setTimeout(function() {
                    a.error = 0;
                }, 5000);
            }
        }

    }
})();
